import { components } from "@certn/legacy-api/generated-schemas/people";

import { ConvictionInputField } from "./ConvictionInputField";
import { ConvictionSummaryField } from "./ConvictionSummaryField";
import { FieldType } from "../types";

export function ConvictionField(
  field: components["schemas"]["ConvictionsCheckField"]
): FieldType<components["schemas"]["ConvictionsCheckField"]> {
  return {
    field,
    inputElement: <ConvictionInputField key={field.name} field={field} />,
    summaryElement: () => (
      <ConvictionSummaryField key={field.name} field={field} />
    ),
    initialValue: field.value,
  };
}
